import type { Theme } from "../types/Theme";
import { shouldUseModernTheme } from "../theme/navigationButtonThemeColors";

/** Top bar: legacy only (historically always top; hidden when modern theme moves it to bottom nav). */
export function shouldShowViewResponsesAtTop(theme: Theme, showSecurityQuestion: boolean): boolean {
    return (
        Boolean(theme.ViewResponsesButtonVisible) &&
        !showSecurityQuestion &&
        !shouldUseModernTheme(theme)
    );
}

/** Bottom (or top) nav row: modern theme shows on bottom only; legacy uses {@link Theme.ViewResponsesButtonPlacement}. */
export function shouldShowViewResponsesAtNavPosition(
    theme: Theme,
    navPosition: "top" | "bottom",
    showSecurityQuestion: boolean,
): boolean {
    if (!theme.ViewResponsesButtonVisible || showSecurityQuestion) {
        return false;
    }

    if (shouldUseModernTheme(theme)) {
        return navPosition === "bottom";
    }

    const placement = theme.ViewResponsesButtonPlacement ?? "top-right";
    return placement.includes(navPosition);
}
